import { apiProvider } from './utilities/Provider';

const login = (email, password) =>
    apiProvider.post('agency/account/login', { email, password });

const getMe = () =>
    apiProvider.get('users/me');

const getProfile = () =>
    apiProvider.get('agency/account/me');

const updateProfile = (data) =>
    apiProvider.put('agency/account/me', data);

const changePassword = (currentPassword, newPassword) =>
    apiProvider.post('agency/account/change-password', { currentPassword, newPassword });

const setupTwoFactor = () =>
    apiProvider.post('agency/account/2fa/setup');

const confirmTwoFactor = (code) =>
    apiProvider.post('agency/account/2fa/confirm', { code });

const disableTwoFactor = ({ password, code }) =>
    apiProvider.post('agency/account/2fa/disable', { password, code });

const verifyTwoFactorLogin = (pendingToken, code) =>
    apiProvider.post('agency/account/2fa/verify-login', { pendingToken, code });

const resendTwoFactorLoginCode = (pendingToken) =>
    apiProvider.post('agency/account/2fa/resend-login-code', { pendingToken });

const sendEmailTwoFactorSetupCode = () =>
    apiProvider.post('agency/account/2fa/email/send-code');

const confirmEmailTwoFactor = (code) =>
    apiProvider.post('agency/account/2fa/email/confirm', { code });

const getChatConsents = () =>
    apiProvider.get('agency/account/chat-consents');

const updateChatConsents = (data) =>
    apiProvider.put('agency/account/chat-consents', data);

const AccountService = {
    login,
    getMe,
    getProfile,
    updateProfile,
    changePassword,
    setupTwoFactor,
    confirmTwoFactor,
    disableTwoFactor,
    verifyTwoFactorLogin,
    resendTwoFactorLoginCode,
    sendEmailTwoFactorSetupCode,
    confirmEmailTwoFactor,
    getChatConsents,
    updateChatConsents,
};

export default AccountService;
